<div class="mb-5">
  <h2 class="text-2xl font-bold leading-8 text-color">{{ title }}</h2>
  <p class="mt-1 text-base subtext-color">{{ subtitle }}</p>
</div>
